// extracted by mini-css-extract-plugin
export default {"twoColumnsLayout":"h0jUi","left":"vMOK2","right":"xJEhu"};